<script setup>
  import { ref, onMounted, computed } from 'vue';
  import Loader from './ui/Loader.vue';
  import HistoryChart from './HistoryChart.vue';

  const props = defineProps({
    url: {
      type: String,
      required: true
    }
  });

  const loading = ref(true);
  const error = ref(null);
  const data = ref(null);

  async function fetchData() {
    loading.value = true;
    error.value = null;

    try {
      const response = await fetch(props.url, {
        headers: {
          'Accept': 'application/json',
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]')?.content
        }
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      data.value = await response.json();
    } catch (e) {
      console.error('Error fetching dashboard data:', e);
      error.value = 'Error fetching data';
    } finally {
      loading.value = false;
    }
  }

  onMounted(() => {
    fetchData();
  });
</script>

<template>
  <!-- Loading state -->
  <div v-if="loading" class="text-center py-5">
    <Loader />
    <p class="mt-3">Loading...</p>
  </div>

  <!-- Error state -->
  <div v-else-if="error" class="alert alert-danger" role="alert">
    {{ error }}
  </div>

  <!-- Dashboard content -->
  <div v-else-if="data">
    <!-- History Chart -->
    <HistoryChart :series="data.series" :data="data.data" />
  </div>
</template>

<style scoped>
</style>
